import React from 'react';

import {
  nfceEmAndamento,
  SituacaoFiscal,
  STATUS_FINAIS_OK,
} from './useSituacaoNfce';
import * as S from './styles';

interface NfceStatusChipProps {
  situacao: SituacaoFiscal | null;
  onClick: () => void;
}

/** Situação da NFC-e do pedido no cabeçalho do monitor. */
export function NfceStatusChip({
  situacao,
  onClick,
}: NfceStatusChipProps): JSX.Element | null {
  if (!situacao?.empresaHabilitada) return null;
  const { emissao } = situacao;

  let tone: 'ok' | 'erro' | 'aguarde';
  let texto: string;
  if (emissao && STATUS_FINAIS_OK.includes(emissao.status)) {
    tone = 'ok';
    texto =
      emissao.status === 'contingency'
        ? `NFC-e nº ${emissao.numero ?? '-'} em contingência`
        : `NFC-e nº ${emissao.numero ?? '-'} autorizada`;
  } else if (nfceEmAndamento(situacao)) {
    tone = 'aguarde';
    texto = 'Gerando NFC-e…';
  } else if (emissao?.status === 'rejected') {
    tone = 'erro';
    texto = 'NFC-e não emitida';
  } else if (emissao?.status === 'pending') {
    tone = 'aguarde';
    texto = 'NFC-e em rascunho';
  } else {
    return null;
  }

  return (
    <S.Chip
      type="button"
      tone={tone}
      onClick={onClick}
      title="Ver a NFC-e do pedido"
    >
      {texto}
    </S.Chip>
  );
}
